export default __webpack_public_path__ + "static/map-pink-ceb221de590691819025532c924b514f.jpg";